// extracted by css-extract-rspack-plugin
export default {"search":"CvcFOkZY6K0Mf3EQ"};